export default __webpack_public_path__ + "dc63086a1eb7d5023cba7c256e0287ab.ico";